import { render, staticRenderFns } from "./VEstimatesDocumentsTableRow.vue?vue&type=template&id=3dcc8de0&"
import script from "./VEstimatesDocumentsTableRow.vue?vue&type=script&lang=ts&"
export * from "./VEstimatesDocumentsTableRow.vue?vue&type=script&lang=ts&"
import style0 from "./VEstimatesDocumentsTableRow.vue?vue&type=style&index=0&id=3dcc8de0&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports